export default __webpack_public_path__ + "media/images/iui/iui-logo-touch-icon-b2bba3be8772de60243dc730fb40481a.png";